import React from 'react';

const NetworkErrorDiv = (props) => {
    return (
        <div className="centered-content network-error">
            {props.title && <div className="error-title">{props.title}</div>}
            <br />
            {props.description &&
                <div className="error-detail">{props.description}</div>
            }
        </div>
    );
};

export default NetworkErrorDiv;


// WEBPACK FOOTER //
// ./src/components/common/networkErrorDiv.js